import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Background from './Background';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen text-white">
      <Background />
      <Navbar />
      <main className="relative z-10 pt-20">{children}</main>
      <Footer />
    </div>
  );
}
